import { Field, Float, ID, ObjectType } from 'type-graphql'
import { Product } from '../product/Product'
import type { OrderPaymentStatusEnum } from './OrderPaymentStatusEnum'

@ObjectType()
export class InvoiceViewPayment {
  @Field(() => ID)
  _id: string

  @Field(() => String)
  status: string
}

@ObjectType()
export class InvoiceViewAddress {
  @Field(() => ID)
  _id: string

  @Field(() => String)
  fullAddress: string
}

@ObjectType()
export class InvoiceViewUom {
  @Field(() => ID)
  _id: string

  @Field(() => String)
  name: string
}

@ObjectType()
export class InvoiceViewItem {
  @Field(() => ID)
  _id: string

  @Field(() => Float)
  quantity: number

  @Field(() => Float)
  price: number

  @Field(() => Float)
  net: number

  @Field(() => String, { nullable: true })
  remarks?: string

  @Field(() => InvoiceViewUom, { nullable: true })
  uom?: InvoiceViewUom

  @Field(() => Product)
  product: Product
}

/**
 * The read model a public invoice link opens: only what the invoice page shows. It is a bare
 * `@ObjectType()` so no customer, member, communication or tenant field can be selected on it.
 */
@ObjectType()
export class InvoiceView {
  @Field(() => ID)
  _id: string

  @Field(() => String, { nullable: true })
  code?: string

  @Field(() => String, { nullable: true })
  status?: string

  @Field(() => Date)
  createdAt: Date

  @Field(() => String, { nullable: true })
  paymentStatus?: OrderPaymentStatusEnum

  @Field(() => [InvoiceViewPayment])
  payments: InvoiceViewPayment[]

  @Field(() => InvoiceViewAddress, { nullable: true })
  billingAddress?: InvoiceViewAddress

  @Field(() => InvoiceViewAddress, { nullable: true })
  shippingAddress?: InvoiceViewAddress

  @Field(() => Float)
  gross: number

  @Field(() => Float)
  shippingFee: number

  @Field(() => Float)
  taxAmount: number

  @Field(() => Float)
  discount: number

  @Field(() => Float)
  net: number

  @Field(() => [InvoiceViewItem])
  items: InvoiceViewItem[]
}
